import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify';

// Erlaubte Tags/Attribute fuer gerenderte Prozess-Beschreibungen (#1472).
// img + Headings + a (Prozess-/External-Links) + Listen/Formatierung.
const PROZESS_PURIFY = {
  ALLOWED_TAGS: ['p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'strike', 'sub', 'sup', 'a', 'ul', 'ol', 'li', 'code', 'pre', 'blockquote', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div', 'span', 'hr', 'img'],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'width', 'height', 'class', 'title', 'style'],
};

/**
 * ProcessHtmlView — rendert gespeichertes Prozess-Beschreibungs-HTML (#1472, BR-35).
 *
 * Sanitisiert mit DOMPurify (img + Headings + Links erlaubt) und faengt Klicks auf
 * interne Prozess-Links (href="/prozesse/:id") ab → React-Router-Navigation statt
 * Full-Page-Reload. Externe Links oeffnen normal.
 */
export default function ProcessHtmlView({ html, className = '', onEmptyClick, emptyPlaceholder }) {
  const navigate = useNavigate();

  const handleClick = useCallback((e) => {
    const anchor = e.target.closest?.('a');
    if (!anchor) return;
    const href = anchor.getAttribute('href') || '';
    // Interner Prozess-Link → SPA-Navigation
    if (href.startsWith('/prozesse/')) {
      e.preventDefault();
      navigate(href);
    }
  }, [navigate]);

  const clean = html ? DOMPurify.sanitize(html, PROZESS_PURIFY) : '';

  if (!clean) {
    return (
      <p
        className={`text-sm text-[var(--text-secondary,#4B5563)] cursor-text hover:bg-[var(--bg-hover,#FAFAFE)] rounded-lg px-2 py-1.5 -mx-2 transition-colors min-h-[2rem] ${className}`}
        onClick={onEmptyClick}
      >
        <span className="text-[var(--text-tertiary,#6B7280)] italic">{emptyPlaceholder}</span>
      </p>
    );
  }

  return (
    <div
      className={`prose prose-sm max-w-none text-[var(--text-secondary,#4B5563)] prozess-richtext-view ${className}`}
      onClick={handleClick}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
